import type { DefaultExportSettings } from '@cartwhl/common/types';
import { parseDefaultExportType } from '@cartwhl/common/utils/defaultExportSettings';
import { sanitizePromptAsFilename } from '@cartwhl/common/utils/sanitizePromptAsFilename';
import { trackOutputExported } from '@cartwhl/common/utils/trackOutputExported';

import { noticesStore } from 'stores';
import { EXPORT_TYPES } from 'stores/animationGenerationStore';

export const exportAnimationFile = (
  href: string,
  extension: string,
  prompt?: string,
) => {
  if (href) {
    let filename = `Cartwheel-export.${extension}`;
    if (prompt) {
      const sanitizedPrompt = sanitizePromptAsFilename(prompt, 50);
      filename = `Cartwheel-${sanitizedPrompt}.${extension}`;
    }
    const aTag = document.createElement('a');
    aTag.href = href;
    aTag.download = filename;
    document.body.appendChild(aTag);
    aTag.click();
    aTag.remove();
    noticesStore.success('Download has begun!');
    trackOutputExported({
      eventSource: 'studio',
      app: 'studio',
      format: extension,
      fileCount: 1,
    });
  }
};

export function downloadTypeFromDefaultExportSettings(
  settings: DefaultExportSettings | undefined,
  options?: { allowQpos?: boolean },
): { tab: EXPORT_TYPES; format: EXPORT_TYPES } | undefined {
  const parsed = parseDefaultExportType(settings?.exportType);
  if (!parsed) {
    return undefined;
  }

  const format = parsed as unknown as EXPORT_TYPES;
  if (
    format === EXPORT_TYPES.FBX_BLENDER ||
    format === EXPORT_TYPES.FBX_MAYA ||
    format === EXPORT_TYPES.FBX_ROBLOX ||
    format === EXPORT_TYPES.FBX_UNREAL
  ) {
    return { tab: EXPORT_TYPES.FBX_MAYA, format };
  }
  if (format === EXPORT_TYPES.MA || format === EXPORT_TYPES.MB) {
    return { tab: EXPORT_TYPES.MA, format };
  }
  if (format === EXPORT_TYPES.QPOS && !options?.allowQpos) {
    return undefined;
  }
  if (
    format === EXPORT_TYPES.MP4 ||
    format === EXPORT_TYPES.BVH ||
    format === EXPORT_TYPES.GLB ||
    format === EXPORT_TYPES.QPOS
  ) {
    return { tab: format, format };
  }

  return undefined;
}
